{
  "Title": "Doka App Store",
  "GetApplicationsError": {
    "Title": "Error fetching Applications!",
    "Message": "An error occured while fetching the Applications."
  },
  "AppDetails": {
    "Testers": "Tester",
    "Releases": "Releases",
    "isNoTester": "You are not a tester for this stage.",
    "isNoTesterDesc": "Please request to be added as a tester for this stage.",
    "Sorting": {
      "Version": "Version",
      "Date": "Date"
    },
    "Release": {
      "Title": "Release",
      "Version": "Version",
      "ReleaseDate": "Release Date",
      "ReleaseNotes": "Release Notes",
      "Stage": "Stage",
      "Save": "Save",
      "Cancel": "Cancel",
      "Latest": "Latest",
      "Deployed": "Deployed",
      "Error": {
        "Title": "Error saving release!",
        "Message": "An error occurred while saving the release."
      }
    },
    "SetAsDeployed": "Set as deployed",
    "CurrentlyDeployed": "Currently deployed",
    "NoTesters": "There are currently no testers for this stage.",
    "NoReleases": "There are currently no releases for this stage."
  },
  "AddTester": {
    "Title": "Add Tester",
    "SearchPlaceHolder": "Search for a tester",
    "Cancel": "Cancel",
    "Confirm": "Confirm"
  },
  "Header": {
    "Logout": "Logout"
  },
  "Logout": {
    "Header": "Logout Successful!",
    "Description": "You have successfully logged out. Do you want to return to the application?",
    "ReturnToApplication": "Return to Application",
    "Logout": "Logout"
  },
  "Nav": {
    "Apps": "Apps",
    "Overview": "Overview"
  },
  "Unauthorized": {
    "NoPermissions": "You do not have access to this application.",
    "NoPermissionsDesc": "Please request the role 'App Portal User' in the Yardmanager.",
    "LinkToYM": "Open Yardmanager"
  }
}
